import 'jquery.cookie';
import moment from 'moment';
import 'moment/locale/ru';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import getCustomerHash from '@/js/desktop/components/account/service/getCustomerHash';

const trackingDefaultDataTypesHydrator = async (options) => {
    const gaId = $.cookie('_ga');
    const yandexId = $.cookie('_ym_uid');
    const domain = window.location.host;
    const timestamp = options.timestamp ? moment(options.timestamp).format('YYYY-MM-DD HH:mm:ss') : null;
    const { ab_identity, ab_identity_value } = getABTestValue;
    const customerHash = await getCustomerHash();

    return _.extend({}, {
        timestamp,
        ga_id: gaId || 0,
        ya_id: yandexId || 0,
        customer_hash: customerHash,
        domain,
        ab_identity,
        ab_identity_value,
    });
};

export default trackingDefaultDataTypesHydrator;